export const generateCustomPaymentType = name => {
  return name
    .replace(/[\W_]+/g, '')
    .toUpperCase()
    .slice(0, 10);
};
